"use client";

import { useEffect, useRef } from "react";
import { track } from "@/lib/analytics/tracker";
import type { GeoMarketView } from "@/lib/analytics/geo-pageview";

export function GeoMarketViewEvent({ properties }: { properties: GeoMarketView }) {
  const lastPath = useRef<string | null>(null);
  const path = `${properties.product_slug}/${properties.state}/${properties.city ?? ""}`;
  useEffect(() => {
    if (lastPath.current === path) return;
    lastPath.current = path;
    track("market.viewed", properties);
  }, [path, properties]);
  return null;
}
